import { render, staticRenderFns } from "./u-lnb-topline-border.vue?vue&type=template&id=b2f61e68&scoped=true"
import script from "./u-lnb-topline-border.vue?vue&type=script&lang=js"
export * from "./u-lnb-topline-border.vue?vue&type=script&lang=js"
import style0 from "./u-lnb-topline-border.vue?vue&type=style&index=0&id=b2f61e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f61e68",
  null
  
)

export default component.exports